import React from "react";
import ProjectLists from "../DashboardProject/ProjectLists";
import { ProjectStatuses } from "../../constants/Status";


const ProjectsListDashboard = () => {
  // document.title = "Approved-Projects";
  // document.title="Vector Maps | Velzon - React Admin & Dashboard Template";
  return (
    <div className="page-content">
      <div className="container-fluid">
        <ProjectLists />
      </div>
    </div>
  );
};

export default ProjectsListDashboard;